define( function() {
	return window.location;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/ajax/var/location.js
 ** module id = 488
 ** module chunks = 2
 **/